__turbopack_context__.v({
  "chatSeparator": "ChatSeparator-module__JEm3sq__chatSeparator",
  "chatSeparatorLeft": "ChatSeparator-module__JEm3sq__chatSeparatorLeft",
  "chatSeparatorLleft": "ChatSeparator-module__JEm3sq__chatSeparatorLleft",
  "chatSeparator__date": "ChatSeparator-module__JEm3sq__chatSeparator__date",
});
